export const GET_TEACHER_REQUEST = 'GET_TEACHER_REQUEST'
export const GET_TEACHER_FAILURE = 'GET_TEACHER_FAILURE'
export const GET_TEACHER_SUCCESS = 'GET_TEACHER_SUCCESS'
export const POST_TEACHER_REQUEST = 'POST_TEACHER_REQUEST'
export const POST_TEACHER_FAILURE = 'POST_TEACHER_FAILURE'
export const POST_TEACHER_SUCCESS = 'POST_TEACHER_SUCCESS'

export const GET_DETAILS_REQUEST = 'GET_DETAILS_REQUEST'
export const GET_DETAILS_FAILURE = 'GET_DETAILS_FAILURE'
export const GET_DETAILS_SUCCESS = 'GET_DETAILS_SUCCESS'
export const GET_SUMMARY_REQUEST = 'GET_SUMMARY_REQUEST'
export const GET_SUMMARY_FAILURE = 'GET_SUMMARY_FAILURE'
export const GET_SUMMARY_SUCCESS = 'GET_SUMMARY_SUCCESS'

export const GET_TEACHER_FINAL_REQUEST = 'GET_TEACHER_FINAL_REQUEST'
export const GET_TEACHER_FINAL_FAILURE = 'GET_TEACHER_FINAL_FAILURE'
export const GET_TEACHER_FINAL_SUCCESS = 'GET_TEACHER_FINAL_SUCCESS'

export const GET_TEACHER_CARD_REQUEST = 'GET_TEACHER_CARD_REQUEST'
export const GET_TEACHER_CARD_FAILURE = 'GET_TEACHER_CARD_FAILURE'
export const GET_TEACHER_CARD_SUCCESS = 'GET_TEACHER_CARD_SUCCESS'

export const POST_PROFILE_COUNT_REQUEST = 'POST_PROFILE_COUNT_REQUEST'
export const POST_PROFILE_COUNT_FAILURE = 'POST_PROFILE_COUNT_FAILURE'
export const POST_PROFILE_COUNT_SUCCESS = 'POST_PROFILE_COUNT_SUCCESS'

export const DISABLE_TEACHER_REQUEST = 'DISABLE_TEACHER_REQUEST'
export const DISABLE_TEACHER_FAILURE = 'DISABLE_TEACHER_FAILURE'
export const DISABLE_TEACHER_SUCCESS = 'DISABLE_TEACHER_SUCCESS'

export const GET_IS_PUBLISH = 'GET_IS_PUBLISH'

export const POST_ACCOUNT_STATUS_REQUEST = 'POST_ACCOUNT_STATUS_REQUEST'
export const POST_ACCOUNT_STATUS_FAILURE = 'POST_ACCOUNT_STATUS_FAILURE'
export const POST_ACCOUNT_STATUS_SUCCESS = 'POST_ACCOUNT_STATUS_SUCCESS'

export const GET_UNPUBLISHED_TEACHERS_REQUEST = 'GET_UNPUBLISHED_TEACHERS_REQUEST'
export const GET_UNPUBLISHED_TEACHERS_FAILURE = 'GET_UNPUBLISHED_TEACHERS_FAILURE'
export const GET_UNPUBLISHED_TEACHERS_SUCCESS = 'GET_UNPUBLISHED_TEACHERS_SUCCESS'

export const GET_REGISTERED_TEACHERS_REQUEST = 'GET_REGISTERED_TEACHERS_REQUEST'
export const GET_REGISTERED_TEACHERS_FAILURE = 'GET_REGISTERED_TEACHERS_FAILURE'
export const GET_REGISTERED_TEACHERS_SUCCESS = 'GET_REGISTERED_TEACHERS_SUCCESS'

export const POST_CONTACT_US_ALL_REQUEST = 'POST_CONTACT_US_ALL_REQUEST'
export const POST_CONTACT_US_ALL_FAILURE = 'POST_CONTACT_US_ALL_FAILURE'
export const POST_CONTACT_US_ALL_SUCCESS = 'POST_CONTACT_US_ALL_SUCCESS'

export const POST_DEGREE_VERIFY_REQUEST = 'POST_DEGREE_VERIFY_REQUEST'
export const POST_DEGREE_VERIFY_FAILURE = 'POST_DEGREE_VERIFY_FAILURE'
export const POST_DEGREE_VERIFY_SUCCESS = 'POST_DEGREE_VERIFY_SUCCESS'
